import React, { FC, memo, useEffect } from 'react'
import { toast } from 'react-toastify'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Modal } from '../../../../../components/Dashboard/Modal'
import { useRest } from '../../../../../components/Context'
import { launchWebSdk } from '../../../../../utils/launchWebSdk'

const useStyles = makeStyles(() => ({
  container: {
    boxSizing: 'border-box',
    width: 738,
  },
  sumsub: {
    width: '100%',
    backgroundColor: '#FAFAFA',
  },
}))

interface IEditUserProfile {
  isOpen: boolean
  modalClose: () => void
  clearStep: string
  userIdSf: string
}

const EditUserProfilePopup: FC<IEditUserProfile> = ({ isOpen, modalClose, clearStep, userIdSf }) => {
  const classes = useStyles()
  const { rxios } = useRest()

  useEffect(() => {
    // eslint-disable-next-line
    isOpen &&
      rxios.post(`user/change/sum-sub`, { userIdSf, clearStep }).subscribe(
        // eslint-disable-next-line
        async (next: any) => {
          const { accessToken, apiUrl } = next
          await launchWebSdk('#sumsub-websdk-container', apiUrl, accessToken)
        },
        (error) => {
          toast.error(error.response.data.message)
        },
      )
    // eslint-disable-next-line
  }, [isOpen, rxios])

  return (
    <Modal title="User Authentication" isOpen={isOpen} modalClose={modalClose} isWidthAuto={true} isSubmit>
      <Grid container className={classes.container}>
        <div id="sumsub-websdk-container" className={classes.sumsub} />
      </Grid>
    </Modal>
  )
}

export const MemoEditUserProfile = memo(EditUserProfilePopup)
